import { createEditor, Editor } from "slate";
import { withHistory } from "slate-history";
import { withReact } from "slate-react";

import withDynamicVariables from "../../util/withDynamicVariables";
import ImageUploadCallback from "../type/ImageUploadCallback";

import withImages from "./withImages";
import withLinks from "./withLinks";
import withResourceLinks from "./withResourceLinks";

// Builds an EmailBody editor with the full plugin stack (image/link/resource-link/dynamic-variable
// inline & void rules). Used both for the live editor and for one-off value normalization.
const createEmailBodyEditor = (onImageUpload?: ImageUploadCallback) =>
  [
    (editor: Editor) => withImages(editor, onImageUpload),
    withDynamicVariables,
    withLinks,
    withResourceLinks,
  ].reduce((editor, plugin) => plugin(editor), withReact(withHistory(createEditor())));

export default createEmailBodyEditor;
